var htmlEscapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};
var hasLetterOrNumber = function () {
  try {
    return new RegExp('[\\p{L}\\p{N}_]', 'u');
  } catch (_unused) {
    return new RegExp(/\w/i);
  }
}();
var regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var regexHasEscapedHtml = RegExp(regexEscapedHtml.source);
function unescape(value) {
  return value && regexHasEscapedHtml.test(value) ? value.replace(regexEscapedHtml, function (character) {
    return htmlEscapes[character];
  }) : value;
}
export function isPartHighlighted(parts, i) {
  var _parts$isHighlighted, _parts, _parts$isHighlighted2, _parts2;
  var current = parts[i];
  var isNextHighlighted = (_parts$isHighlighted = (_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) !== null && _parts$isHighlighted !== void 0 ? _parts$isHighlighted : true;
  var isPreviousHighlighted = (_parts$isHighlighted2 = (_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) !== null && _parts$isHighlighted2 !== void 0 ? _parts$isHighlighted2 : true;
  if (!hasLetterOrNumber.test(unescape(current.value)) && isPreviousHighlighted === isNextHighlighted) {
    return isPreviousHighlighted;
  }
  return current.isHighlighted;
}